import * as React from "react";


import { Dialog } from "../components/dialog.component";
import { Button, Chip, FormControl, FormHelperText, TextField, Typography } from "@mui/material";
import Compact from "@uiw/react-color-compact";
import { Team } from "../models/auth";



export interface TeamDialogProps {
  open: boolean
  isEdit: boolean,
  name?: string,
  desc?: string,
  hex?: string,
  id?: string,
  onClose: () => void;
  onConfirm: (val: Partial<Team>) => void;
  onDelete: (id: string) => void
  children: React.ReactNode
}

type TeamFormState = { hex: string, teamName: string, teamDesc: string };


export function TeamDialog(props: TeamDialogProps): React.ReactElement<any, any> {

  const [formState, setFormState] = React.useState<TeamFormState>({
    teamName: props.name || "",
    teamDesc: props.desc || "",
    hex: props.hex || ""
  });

  function formUpdate(key: keyof TeamFormState, val: string) {
    setFormState((prev) => {
      return {
        ...prev,
        [key]: val
      }
    })
  }

  function onConfirm() {
    props.onConfirm(
      {
        teamName: formState.teamName,
        teamDesc: formState.teamDesc,
        teamColor: formState.hex,
      }
    )
  }

  function onDelete() {
    props.onDelete(props.id as string);
  }

  return (
    <Dialog
      fullWidth={true}
      title={props.isEdit ? "Edit Team" : "Create Team"}
      open={props.open}
      onClose={props.onClose}
      loading={false}
      onConfirm={onConfirm}>
      <div className="team-dialog-wrapper">
        {props.isEdit && <Chip
          label={`@${formState.teamName}`}
          className="team-chip team-chip-color"
          style={{
            backgroundColor: formState.hex,
          }}
        />}
        <FormControl fullWidth>
          <TextField
            label="Team Name"
            variant="outlined"
            value={formState.teamName}
            onChange={e => formUpdate("teamName", e.target.value)}
          />
          <FormHelperText>Enter unique team name</FormHelperText>
        </FormControl>
        <FormControl fullWidth>
          <TextField
            label="Team Description"
            variant="outlined"
            multiline
            value={formState.teamDesc}
            onChange={e => formUpdate("teamDesc", e.target.value)}
          />
          <FormHelperText>Describe the purpose of this team</FormHelperText>
        </FormControl>
        <Typography>
          Team Color
        </Typography>
        <Compact
          color={formState.hex}
          className="color-chooser color-chooser-shadow"
          onChange={(color) => {
            formUpdate("hex", color.hex)
          }}
        />
        {props.isEdit && <Button
          className="delete-button"
          variant="contained"
          color="secondary"
          onClick={onDelete}
        >DELETE TEAM</Button>}
      </div>
      {props.children}
    </Dialog>
  )
}